import React, { useEffect, useState } from 'react';

import Button from 'components/shared/Buttons/Button';
import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Modal from 'components/shared/Modal/Modal';

import FacilityProviderForm from './lib/FacilityProviderForm';

export default function NewFacilityProvider({
  formik,
  isLoading,
  open,
  type,
  handleClose,
  handleSubmit,
  states,
  handleDeletion,
  isDeleting
}) {
  const currentState = states.find((state) => state.value == formik.values.facility_state);
  const [selectedState, setSelectedState] = useState(currentState);
  const [deletionModal, setDeletionModal] = useState(false);

  useEffect(() => {
    setSelectedState(currentState);
  }, [states]);

  const handleSelectState = (state) => {
    setSelectedState(state);
    formik.setFieldValue('facility_state', state?.value);
  };

  const customModalTitle = (type) => {
    if (type == 'create') {
      return 'Create new facility provider';
    }
    if (type == 'update') {
      return 'Update facility provider';
    }
  };

  return (
    <>
      <Confirm
        isOpen={deletionModal}
        title="Delete Facility Provider"
        message="Are you sure you want to delete this facility provider?"
        variant="danger"
        icon="trash-mono"
        handleClose={() => setDeletionModal(false)}
        handleContinue={() => {
          handleDeletion(formik.values.id);
        }}
        loading={isDeleting}
      />
      <Modal
        className="min-w-[50dvw]"
        slideFromRight
        handleOpen={open}
        handleClose={handleClose}
        title={customModalTitle(type)}
        footer={
          <>
            <Button
              className="mr-auto"
              text="Cancel"
              color="neutral"
              outlined
              onClick={handleClose}
            />
            {formik.values.id && type == 'update' && (
              <Button text="Delete" color="danger" onClick={() => setDeletionModal(true)} />
            )}
            <Button text={customModalTitle(type)} loading={isLoading} onClick={handleSubmit} />
          </>
        }>
        <FacilityProviderForm
          formik={formik}
          selectedState={selectedState}
          handleSelectState={handleSelectState}
          states={states}
        />
      </Modal>
    </>
  );
}
